<ul class="slider-picker-options">
    <li *ngFor="let option of options" 
        class="slider-picker-option label" 
        [ngClass]="{'selected': selected === option.value}" 
        (click)="pick(option)">
        <i *ngIf="option.icon" class="uil uil-{{option.icon}}"></i> {{option.label | translate}}
    </li>
</ul>
